import { ReactElement } from 'react';
import { useTheme } from 'styled-components';

import { VisitHistory } from '@dreryk/egabinet-visit-frontend-api';

import { ControlsBar, StyledFlex, Text } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';

import { historicalVisitsTranslationKeys } from '../translations';
import { VisitDateTime } from '../common/visit/VisitDateTime';
import { VisitPractitioner } from '../common/visit/VisitPractitioner';
import { VisitLocationText } from '../visit/visitLocation/VisitLocationText';
import { VisitEncounterModeText } from '../visit/visitEncounterMode/VisitEncounterModeText';
import { VisitConfidentialityText } from '../visit/visitConfidentiality/VisitConfidentialityText';

import { VisitHistoryConfidentialAccessLink } from './VisitHistoryConfidentialAccessLink';

type VisitHistoryWithoutConfidentialDetailsPanelProps = {
   readonly visitHistory: VisitHistory;
};

export const VisitHistoryWithoutConfidentialDetailsPanel = (
   props: VisitHistoryWithoutConfidentialDetailsPanelProps
): ReactElement => {
   const theme = useTheme();

   return (
      <StyledFlex direction={'column'} gap={'16px'}>
         <ControlsBar testId={'visit'}>
            <ControlsBar.Main position={'left'}>
               <VisitDateTime
                  plannedBeginDate={props.visitHistory.appointmentBeginDate}
                  plannedEndDate={props.visitHistory.appointmentEndDate}
               />
               <VisitPractitioner practitioner={props.visitHistory.practitioner} />
               <VisitLocationText
                  name={props.visitHistory.visitLocationName}
                  address={props.visitHistory.visitLocationAddress}
               />
               {protectFeature(
                  'performingVideoConsultations',
                  <VisitEncounterModeText visitEncounterMode={props.visitHistory.encounterMode} />
               )}
               <StyledFlex alignItems={'center'} gap={'8px'}>
                  <VisitConfidentialityText restricted />
                  {props.visitHistory.pendingVisitConfidentialAccess ? (
                     <Text testId={'confidentialAccessPending'} color={theme.backgroundDark}>
                        <Translate>{historicalVisitsTranslationKeys.confidentialAccess.pending}</Translate>
                     </Text>
                  ) : (
                     <VisitHistoryConfidentialAccessLink visitId={props.visitHistory.id} />
                  )}
               </StyledFlex>
            </ControlsBar.Main>
         </ControlsBar>
      </StyledFlex>
   );
};
